module.exports = __webpack_public_path__ + "static/empfang.a140e86e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/empfang.jpg
// module id = 459
// module chunks = 70144966829960